module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), (_vm.franquias.length != 0) ? _c('div', {
    staticClass: "box-body"
  }, _vm._l((_vm.franquias), function(franquia) {
    return _c('div', {
      key: franquia.total,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "form-group col-xs-12 col-sm-4 col-md-8"
    }, [_c('div', {
      staticClass: "col-sm-3 control-label"
    }, [_vm._v(_vm._s(franquia.trimestre_ano))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3 control-label"
    }, [_vm._v(_vm._s(_vm.formatarMoeda(franquia.valor_total)))]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3 control-label"
    }, [_vm._v(_vm._s(franquia.total_unidades) + " unidades")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('b-button', {
      attrs: {
        "variant": "primary",
        "disabled": _vm.loading
      },
      on: {
        "click": function($event) {
          return _vm.glosar(franquia.meses, franquia.trimestre, franquia.ano)
        }
      }
    }, [_vm._v("\n              " + _vm._s(_vm.loadingTrimestre == franquia.trimestre ? 'aguarde...' : 'Glosar') + "\n            ")])], 1)])])
  }), 0) : _c('div', {
    staticClass: "box-body"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Não há pendências")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h2', [_vm._v("Pendências de Franquia pelo Fornecedor")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f299e44c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/aplicacaoGlosaFranquias/AplicarGlosaFranquias.vue
// module id = 1029
// module chunks = 1